import { inject } from 'vue';
import dayjs from 'dayjs';

export const dayjsKey = Symbol.for('day.js');

export default function(): typeof dayjs {
  return inject<typeof dayjs>(dayjsKey)!;
}
